import React,{ useState } from  'react'
import CommonHeader2 from 'components/shared/CommonHeader2';
import {protectedRoutes} from 'config/routes'
import { Route, Switch} from 'react-router-dom';
import {getStringHash} from 'libs/utils';



const NavigationPage = props => {
    const { history } = props
    const [filterParams, setFilterParams] = useState({})
    const handleFilter = ({artist, station, substation} ) => {
        setFilterParams({artist: artist, station: station, substation: substation})
        history.push('/user/search-result')
    }
    return (

        <div className="page-width">
            <div className="container-fluid">
                <div className="content-width">
                    <CommonHeader2 { ...props} filter={handleFilter}/> 
                    <Switch> 
                        {
                            protectedRoutes.map( ({path , WrappedComponent, exact, isProtected, isSearch}) =>(
                                <Route 
                                    key={getStringHash(path)} 
                                    path={`${props.match.url}${path}`} 
                                    render={ () => isSearch ? (<WrappedComponent filterParams={filterParams} { ...props}/>) : (<WrappedComponent { ...props} />)  } 
                                    exact={exact}/>
                            ))
                        }
                    </Switch>   
                    {/* <WrappedComponent  {...this.props}/> */}
                    {/* <CommonFooter /> */}
                </div>
            </div>
        </div>
    )}


export default NavigationPage;